import { faUserCheck, faUserPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "antd";
import "./FollowButton.css";
import React from "react";

function FollowButton({ isFollowing = false, onClick }) {
  return (
    <Button
      size="small"
      className={`followBtn ${isFollowing && "followingBtn"}`}
      onClick={onClick}
    >
      {isFollowing ? (
        <FontAwesomeIcon className="rapIconBtn" icon={faUserCheck} />
      ) : (
        <FontAwesomeIcon className="rapIconBtn" icon={faUserPlus} />
      )}

      <span className="rapTextBtn">
        {isFollowing ? "Đang theo dõi" : "Theo dõi"}
      </span>
    </Button>
  );
}

export default FollowButton;
